//import "./modules/swup.js"
import "./modules/oxg.js"
import "./modules/app-frame.js"
import "./modules/menu-toggle.js"
import {oxgFnByName} from './modules/fn-by-name.js'
import {for_each_in} from "./modules/arrays.js"
import {map} from "./modules/arrays.js" 
import {filter} from "./modules/arrays.js"
import "./modules/intersection-observer.js"
import "./modules/show-more-less.js"
import "./modules/feed-items.js"
import "./modules/country-param.js"
import "./modules/legal-nav.js"
import "./modules/swup.js"

//jQuery additional var
const jq = jQuery

/* ------------------------------------------------------------------------------------------------------------------
--------------------------------------------------------------------- DOM Loaded
------------------------------------------------------------------------------------------------------------------ */

/* ANCHOR ---- Responsive Type on Splash Screen ------- */

function scaleTypeSplash() {
  const hl = document.querySelector('.oxg-splash-heading');
  const sl = document.querySelector('.oxg-splash-subline');
  if (!sl || !hl) return;
  if ((window.oxg.win.h < 1000)) {
    hl.classList.add('is-reduced-size');
    sl.classList.add('is-reduced-size');
  } else {
    hl.classList.remove('is-reduced-size');
    sl.classList.remove('is-reduced-size');
  }
}

/* ANCHOR ---- Responsive Type on House of Wella Pages ------- */

function scaleTypeHoW() {
  const how = document.querySelector('.oxg-house-of-wella');
  if (!how) return;
  if (window.oxg.win.h < 900) {
    how.classList.add('is-reduced-size');
  } else {
    how.classList.remove('is-reduced-size');
  }
}

/* ANCHOR ---- Set True and Virtual Viewport CSS Vars ------- */

function setViewportCSSVars() {
  const viewPortHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
  document.documentElement.style.setProperty('--vh', `${viewPortHeight * 0.01}px`);
  const appContainer = document.querySelector('#oxg-app-frame');
  if (appContainer) {
    const virtualViewPortHeight = appContainer.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--appHeight', `${virtualViewPortHeight}px`);
    document.documentElement.style.setProperty('--vvh', `${virtualViewPortHeight * 0.01}px`);
  } else {
    document.documentElement.style.setProperty('--vvh', `${viewPortHeight * 0.01}px`);
  }
}

setViewportCSSVars();

/* ANCHOR ---- Resize & Orientation Change -------------------------- */

window.addEventListener('appFrameSet', ()=> {
  console.log('appFrameSet Event received in main.js');
  setViewportCSSVars()
});

window.addEventListener('appFrameRemoved', ()=> {
  console.log('appFrameRemoved Event received in main.js');
  setViewportCSSVars()
});

window.addEventListener('resize', ()=> {
  setViewportCSSVars()
});

window.addEventListener('orientationchange', ()=> {
  setViewportCSSVars()
});

/* ANCHOR ---- DOM Loaded -------------------------- */

document.addEventListener('DOMContentLoaded', () => {

  console.log(performance.now() + ': DOM Content loaded')
  const mainJsEvent = new Event('mainJsLoaded');
  document.dispatchEvent(mainJsEvent);

  if (window.oxgData && window.oxgData.page_title && window.oxgData.page_title == 'Splash') {
    window.addEventListener('resize', ()=> {
      scaleTypeSplash()
    });

    window.addEventListener('orientationchange', ()=> {
      scaleTypeSplash()
    });
  }

  if (window.oxgData && window.oxgData.page_title && window.oxgData.page_title == 'House of Wella') {
    window.addEventListener('resize', ()=> {
      scaleTypeHoW()
    });

    window.addEventListener('orientationchange', ()=> {
      scaleTypeHoW()
    });
  }

  scaleTypeHoW()
  scaleTypeSplash()

  /* ------------------------------------------------------------------------------------------------------------------
  --------------------------------------------------------------------- Window Loaded
  ------------------------------------------------------------------------------------------------------------------ */

  /* ANCHOR ---- Window Loaded -------------------------- */

  window.onload = function() {
      console.log(performance.now() + ': window loaded')
      setViewportCSSVars()

      //log all global variables and functions to the console
      /* for (var b in window) {
          if (window.hasOwnProperty(b)) console.log(b)
      }*/

  }

});